._thumb-basic_1htep_1 {
  width: var(--thumb-basic-width, 24px);
  height: var(--thumb-basic-height, 24px);
  padding: 2px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  cursor: pointer; }
  .classic-facelift-skin ._thumb-basic_1htep_1:hover:not(._selected_1htep_9):not(._disabled_1htep_9) {
    background: #e2e3ea;
    color: #116dff; }
  .responsive-skin ._thumb-basic_1htep_1:hover:not(._selected_1htep_9):not(._disabled_1htep_9) {
    background: #f4f5f8; }

._disabled_1htep_9 {
  background: #f3f3f3;
  fill: #939393;
  cursor: auto; }

.classic-facelift-skin ._selected_1htep_9 {
  background: #116dff;
  color: #fff; }

.responsive-skin ._selected_1htep_9 {
  background: #dce9ff;
  color: #116dff; }
